import React from "react";
import "../index.css";
import scanningIcon from "../../../img/icon-scanning.gif";
import packagingIcon from "../../../img/icon-packaging.gif";
import ofdIcon from "../../../img/icon-ofd.gif";
const OrderStatusCard = ({ mintuesPassed: mp,orderStatus }) => {
  return (
    <div className="card-wrap ot11">
      <h2 className="ot12">Current Status</h2>
      <div className="ot13">
        <ul className="orderStatus">
          <li
            className={`d-flex align-items-center ${
              mp <= 27 ? "active" : "completed"
            }`}
          >
            <div className="orderStatusIcon">
              <img src={scanningIcon} alt="scanning icon" />
            </div>
            <span >Order Scanned</span>
            <span className="d-none">Scanning the order</span>
          </li>
          <li
            className={`d-flex align-items-center ${
              mp > 27 && mp < 54 ? "active" : mp >= 54 ? "completed" : ""
            }`}
          >
            <div className="orderStatusIcon">
              <img src={packagingIcon} alt="packaging icon" />
            </div>
            <span className="d-none">Order Packed</span>
            <span>Packing the order</span>
          </li>
          <li
            className={`d-flex align-items-center ${
              mp >= 54 && mp < 90 ? "active" : mp >= 90 ? "completed" : ""
            }`}
          >
            <div className="orderStatusIcon">
              <img src={ofdIcon} alt="ofd icon" />
            </div>
            <span className="d-none">Delivered</span>
            <span>Out for Delivery</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default OrderStatusCard;
